module.exports = __webpack_public_path__ + "img/left-arrow-icon.9ab22040.svg";